import React from 'react';
import classnames from 'classnames';
import PaginationButton from './ui/PaginationButton';

function Paginator({
  handlePageChange,
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
}) {
  if (!totalItems || totalPages <= 1) {
    return null;
  }

  const getPageRangeStart = () => {
    if (!totalPages) return 0;
    const pageRangeStart = Math.max(0, currentPage - 5);
    const pageRangeTest = pageRangeStart + 10 > totalPages ? totalPages - 10 : pageRangeStart;
    return Math.max(0, pageRangeTest);
  };

  const pageRangeStart = getPageRangeStart();

  return (
    <div className="mt-3">
      <ul className="pagination" role="navigation">
        <li className={classnames('page-item', {
          active: currentPage === 1,
          disabled: currentPage <= 1,
        })}
        >
          <PaginationButton
            onClick={() => handlePageChange(currentPage - 1)}
            active={false}
            disabled={currentPage <= 1}
            label="« Vorige"
          />
        </li>
        {totalPages
        && Array(Math.min(10, totalPages))
          .fill(1)
          .map((x, y) => x + y + pageRangeStart)
          .map(v => (
            <li
              className={classnames('page-item', {
                active: currentPage === v,
              })}
              key={`page-${v}`}
            >
              <PaginationButton
                onClick={() => handlePageChange(v)}
                active={currentPage === v}
                label={v}
              />
            </li>
          ))}

        <li className={classnames('page-item', {
          active: currentPage === totalPages,
          disabled: currentPage >= totalPages,
        })}
        >
          <PaginationButton
            onClick={() => handlePageChange(currentPage + 1)}
            active={false}
            disabled={currentPage > totalPages}
            label="Volgende »"
          />
        </li>
      </ul>
    </div>
  );
}

Paginator.defaultProps = {

};

export default Paginator;
